import { IconEggCracked } from "@tabler/icons-react";
import type { ViewProps } from "@/types/components";
import { View } from "../View";

export const ErrorView = ({
  title,
  description,
  icon,
  button,
  height = "100%",
}: ViewProps) => {
  const errorIcon = icon || IconEggCracked;

  return (
    <View
      title={title}
      description={description}
      icon={errorIcon}
      button={button}
      height={height}
      color="gray.9"
    />
  );
};
